export const ACTA_API_ERROR = 'acta:api-error';
export const ACTA_API_PAGINATION_COMPLETE = 'acta:api-pagination-complete'; // Signals that all pages have been fetched for a given pagination API
export const ACTA_API_PAGINATION_NEXT_PAGE_COMPLETE = 'acta:api-pagination-next-page-complete'; // Signals that the next page has been fetched for a given pagination API
